import { cn } from "@roman/shared/utils";
import { X } from "lucide-react";

import type { Choice } from "./FilterSelect";

interface Props {
  disabled?: boolean;
  checked: boolean;
  choice: Choice;
  color: string;
  onCheckedChange: () => void;
}

export const ChoiceBar = ({ disabled, choice, color, checked, onCheckedChange }: Props) => {
  const isNotCheckOrDisabled = !checked || disabled;

  return (
    <div
      className={cn(
        "px-[13px] py-[15px] rounded-md flex items-center justify-between w-full",
        disabled ? "cursor-default" : "cursor-pointer",
        disabled ? "pointer-events-none" : "",
      )}
      style={{
        background: isNotCheckOrDisabled ? "#ECECEC" : `${color}1A`,
      }}
      onClick={onCheckedChange}
    >
      <div className="flex items-center space-x-3">
        <div
          className="w-[12px] h-[12px] rounded-full flex-shrink-0"
          style={{
            backgroundColor: isNotCheckOrDisabled ? "#ECECEC" : color,
          }}
        />
        <span className="text-lg font-medium">{choice.name}</span>
      </div>
      {!disabled && checked && (
        <button
          type="button"
          onClick={() => {
            //
          }}
          className="text-gray hover:bg-white/20 rounded-full p-1 transition-colors duration-200"
          aria-label="閉じる"
        >
          <X size={20} />
        </button>
      )}
    </div>
  );
};
